import React from 'react';

import './EmptyCard.scss';

function EmptyCard() {
  return <div className="empty-card-wrapper" />;
}

export default EmptyCard;
